document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.signup-modal');
  const modalCloseButton = document.querySelector('#ModalClose-Signup');
  const form = document.querySelector('#modal-form');
  const modalForm = document.querySelector('.js-modal-form');
  const modalSuccess = document.querySelector('.js-modal-success');
  const errorHighlight = document.querySelector('.error-highlight');
  const modalDelay = 5000; // Delay before showing modal
  const modalCooldown = 3600000; // 1 hour in milliseconds
  let retryCount = 0;
  const maxRetries = 3; // Stop retrying after this

  if (!modal || !form || !modalForm || !modalSuccess) {
    console.error('Modal or form elements not found.');
    return;
  }

  if (localStorage.getItem('modalSignedUp')) {
    return; // Don't show modal if user has signed up
  }

  const lastShown = localStorage.getItem('modalLastShown');
  const now = Date.now();

  if (!lastShown || now - parseInt(lastShown, 10) > modalCooldown) {
    setTimeout(() => {
      modal.classList.add('active');
      localStorage.setItem('modalLastShown', now.toString()); // Update last shown time
    }, modalDelay);
  }

  if (modalCloseButton) {
    modalCloseButton.addEventListener('click', () => {
      modal.classList.remove('active');
    });
  }

  function checkSubmission(formData) {
    const email = formData.get('contact[email]');

    // Check valid email
    if (!isValidEmail(email)) {
      if (errorHighlight) {
        errorHighlight.textContent = 'Please enter a valid email address';
      }
      return;
    }

    // Submit form
    return true;
  }

  function isValidEmail(email) {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(form);

    if (!checkSubmission(formData)) {
      return;
    }

    function submitForm(retryAfter = 0) {
      if (retryCount >= maxRetries) {
        console.warn('Max retry limit reached. Stopping retries.');
        if (errorHighlight) {
          errorHighlight.textContent = 'Too many failed attempts. Please try again later.';
        }
        return; // Stop retrying
      }

      setTimeout(() => {
        fetch('/contact', {
          method: 'POST',
          body: new URLSearchParams(formData),
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html, */*; q=0.01'
          }
        })
          .then(response => {
            if (response.ok) {
              console.log('Form submitted successfully!');
              modalForm.style.display = 'none';
              modalSuccess.style.display = 'block';
              localStorage.setItem('modalSignedUp', 'true');
            } else if (response.status === 429) {
              const retryAfterSeconds = response.headers.get('Retry-After');
              const waitTime = retryAfterSeconds ? parseInt(retryAfterSeconds, 10) * 1000 : 5000;

              retryCount++; // Increment retry attempts
              console.warn(`Rate limited. Retrying after ${waitTime / 1000} seconds (Attempt ${retryCount}/${maxRetries}).`);

              if (errorHighlight) {
                errorHighlight.textContent = `Too many requests. Retrying in ${waitTime / 1000} seconds... (Attempt ${retryCount}/${maxRetries})`;
              }

              submitForm(waitTime); // Retry after delay
            } else {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
          })
          .catch(error => {
            console.error('Error:', error);
            if (errorHighlight) {
              errorHighlight.textContent = 'An error occurred. Please try again.';
            }
          });
      }, retryAfter);
    }

    submitForm(); // First submission attempt
  });
});